export class CancellationToken {
	private rejectFn: ((reason: Error) => void) | null = null;
	private promise: Promise<never>;

	constructor() {
		this.promise = new Promise<never>((_, reject) => {
			this.rejectFn = reject;
		});
	}

	cancel() {
		if (this.rejectFn) {
			this.rejectFn(new Error("Operation cancelled by user"));
		}
	}

	get cancellationPromise() {
		return this.promise;
	}
}
